module.exports = __webpack_public_path__ + "static/img/10009.876683c6.png";